module.exports = __webpack_public_path__ + "img/PImmortal64_ua.4973b3c2.webp";